//import React from 'react'
import { useState } from 'react'


export default function UseDashboard() {

const [IdOperator,setIdOperator]=useState(null)
const [Operator,setOperator]=useState(null)

const [loading,setloading]=useState(false)
const [Message,setMessage]=useState('')
const [idProduct,setidProduct]=useState(null)
const [currentProduct,setcurrentProduct]=useState(null)
const [produit,setproduit]=useState(null)
const [searchValue,setsearchValue]=useState('')
const [CurrentBannerNumber,setCurrentBannerNumber]=useState(0)
const [MaxBannerNumber,setMaxBannerNumber]=useState(0)
const [CurrentTopNumber,setCurrentTopNumber]=useState(0)
const [MaxTopNumber,setMaxTopNumber]=useState(0)


  return {
    
    IdOperator,setIdOperator,
    Operator,setOperator,
    loading,setloading,
    Message,setMessage,
    idProduct,setidProduct,
    produit,setproduit,
    currentProduct,setcurrentProduct,
    searchValue,setsearchValue,
    CurrentBannerNumber,setCurrentBannerNumber,
    MaxBannerNumber,setMaxBannerNumber,
    CurrentTopNumber,setCurrentTopNumber,
    MaxTopNumber,setMaxTopNumber

  }

}
